import axiosAPI from '@/api/axios'

export default {
  async verifyPartner(payload) {
    await axiosAPI.get('/sanctum/csrf-cookie')
    return await axiosAPI.post('/v1/verify', payload)
  },
}
